var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractCourseBadge',{staticClass:"taxi-course-badge",attrs:{"text":"serwis"}})}
var staticRenderFns = []

export { render, staticRenderFns }